<script setup lang="ts">
import { NVirtualList } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  items?: any[]
  itemSize?: number | ((index: number) => number)
  itemKey?: string | ((item: any, index: number) => string | number)
  scrollTo?: number | { index: number; align: 'top' | 'bottom' | 'center' }
  scrollToOptions?: ScrollToOptions
}>(), {
  items: () => [],
  itemSize: 24,
  itemKey: 'key',
  scrollTo: undefined,
  scrollToOptions: undefined,
})

const emit = defineEmits<{
  'scroll': [e: Event]
  'scroll-to': [index: number]
}>()

const attrs = useAttrs()

const onScroll = (e: Event) => {
  emit('scroll', e)
}

const onScrollTo = (index: number) => {
  emit('scroll-to', index)
}
</script>

<template>
  <NVirtualList
    :items="items"
    :item-size="itemSize as any"
    :item-key="itemKey"
    :scroll-to="scrollTo"
    :scroll-to-options="scrollToOptions"
    v-bind="attrs"
    @scroll="onScroll"
    @scroll-to="onScrollTo"
  >
    <template #default="{ item, index }">
      <slot :item="item" :index="index" />
    </template>
  </NVirtualList>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
